import $ from 'jquery';
import EventEmitter from 'events';

class EventsKeywordFilter extends EventEmitter {
  constructor({ forcedKeywords, isMultiMode }) {
    super();

    if (forcedKeywords) {
      this.forcedKeywords = forcedKeywords;
      return;
    }

    this.$el = $('#tn-events-keyword-filter');
    this.$inputs = this.$el.find('.js-tn-events-keyword-filter-input');
    this.$btnReset = this.$el.find('#tn-events-keyword-filter-btn-clear-all-keywords');

    this.userSelectedValues = [];
    this.allKeywordValues = this.$inputs.toArray().map(el => el.value);

    this.$btnReset.on('click', this.onBtnReset.bind(this));
    this.$inputs.on('change', this.onInputChange.bind(this));

    if (isMultiMode) {
      this.$el.addClass('tn-events-keyword-filter--event-listing-multi-mode');
    }

    this.$el.show();
  }

  onBtnReset() {
    this.userSelectedValues = [];

    this.$inputs.prop('checked', false);
    this.$btnReset.attr('disabled', true);
    this.dispatchUpdate();
  }

  onInputChange(event) {
    const value = event.target.value;
    const index = this.userSelectedValues.indexOf(value);

    if (index === -1) {
      this.userSelectedValues.push(value);
    } else {
      this.userSelectedValues.splice(index, 1);
    }

    this.$btnReset.attr('disabled', this.userSelectedValues.length === 0);
    this.dispatchUpdate();
  }

  dispatchUpdate() {
    this.emit(EventsKeywordFilter.UPDATE);
  }

  getSelectedKeywords() {
    if (this.forcedKeywords) {
      return this.forcedKeywords;
    }

    if (this.userSelectedValues.length > 0) {
      return [...this.userSelectedValues];
    }

    return this.allKeywordValues;
  }
}

EventsKeywordFilter.UPDATE = 'tnEventsKeywordFilter:update';

export default EventsKeywordFilter;
